import { render, staticRenderFns } from "./NotasCursados.vue?vue&type=template&id=0819f3e8&scoped=true&"
import script from "./NotasCursados.vue?vue&type=script&lang=js&"
export * from "./NotasCursados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0819f3e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
